import { HasId } from '../interfaces';

export class SurveyNote implements HasId {
    public id: number;
    public userId: number;
    public createdByFirstName: string;
    public createdByLastName: string;
    public created: Date;
    public survey: string;
    public value: string;
    public private: boolean;
    public createdById: number;
}


// WEBPACK FOOTER //
// ./src/models/SurveyNote.tsx